import React, { useState } from 'react';
import { Image, Container, Dropdown, NavDropdown, Nav, Navbar } from "react-bootstrap";
import "../css/NavBar.css";
import dropdownOption from '../JSONs/NavbarJSON';
import PopupPatch from './popupPatch/PopupPatch';
import SMLSLoginModal from "./SmlsLoginModal";
import parse from "html-react-parser";

const Separator = ({ className }) => <div className={
    className ? `separator ${className}` : "separator"
}></div>

const NavBar = () => {

    const [showSMLSLoginModal, setShowSMLSLoginModal] = useState(false);
    const [actionType, setActionType] = useState("");

    const handleSubmitLoan = (e) => {
        setShowSMLSLoginModal(true);
        setActionType("newLoan");
    };

    const handleViewPipeline = (e) => {
        setShowSMLSLoginModal(true);
        setActionType("checkLoan");
    };

    function handleSMLSLoginModalClose() {
        // window.location.reload(false);
        setShowSMLSLoginModal(false);
    }

    /** change thumbnail of navbar toggle icon */
    const iconChanger = () => {

        const navOpenIndicatorClass_closed = document.querySelectorAll('.navbar-collapse')
        const navOpenIndicatorClass_open = document.querySelectorAll('.navbar-collapse.show')

        const navTogglerIcon = document.getElementsByClassName('navbar-toggler-icon')[0]

        if (navOpenIndicatorClass_closed.length !== 0) {
            navTogglerIcon.classList.add('nav-close-icon')
        }

        if (navOpenIndicatorClass_open.length !== 0) {
            navTogglerIcon.classList.remove('nav-close-icon')
        }
    }

    const isPrimeJumbo = process.env.REACT_APP_URL === 'nonconformingloans'

    return (
        <div className="whl-navbar">
            {/* <Image
                className="divider"
                width="100%"
                src={`${imagePath}/Header_line.svg`}
                fluid
                alt="Nav divider"
            /> */}
            <Container fluid className="pr-0">
                <Navbar expand="md">
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" onClick={
                        () => iconChanger()
                    } />
                    <Navbar.Collapse className="pr-0" id="responsive-navbar-nav">
                        <Nav className="ml-md-0s ml-lg-autos">
                            {/* <Separator /> */}
                            <Nav.Link
                                onClick={handleSubmitLoan}
                                rel="noreferrer"
                                className="navLink"
                            >
                                Submit Loan
                            </Nav.Link>
                            <Separator className={
                                `${isPrimeJumbo ? 'prime-jumbo-page-separator' : ''
                                }`
                            } />
                            <Nav.Link
                                onClick={handleViewPipeline}
                                rel="noreferrer"
                                className="navLink"
                            >
                                View Pipeline
                            </Nav.Link>
                            <Separator className={
                                `${isPrimeJumbo ? 'prime-jumbo-page-separator' : ''
                                }`
                            } />
                            <NavDropdown
                                title="Resources"
                                id="resources-dropdown"
                                className="resourcesDrop"
                            >

                                {/* landing page Urls end */}
                                <NavDropdown.Item
                                    href="https://www.swmc.com/wholesale-lending/guidelines"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Program Guide
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    href="https://www.swmc.com"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Sun West Home Page
                                </NavDropdown.Item>
                            </NavDropdown>
                             <Separator className={
                                `${isPrimeJumbo ? 'prime-jumbo-page-separator' : ''
                                }`
                            } /> 
                            <Dropdown>
                                {/* <Dropdown.Toggle className="select-dropdown"> */}
                     {/* commented below code to hide the dropdown options from the navbar */}
                                 <Dropdown.Toggle className={
                                    `select-dropdown${process.env.REACT_APP_URL === 'nonconformingloans' ?
                                        ' prime-jumbo-toggler' : ''
                                    }`
                                }>
                                    {parse(
                                        process.env.REACT_APP_URL === 'conventionalloans' ?
                                            'Conv' :
                                            process.env.REACT_APP_URL === 'non-qmloans' ?
                                                'Non-QM' :
                                            //     process.env.REACT_APP_URL === 'nonconformingloans' ?
                                            //         `Non-Conforming${window.innerWidth > 575 ?
                                            //             '<br/> ' : ' '
                                            //         }Jumbo` :
                                            process.env.REACT_APP_URL === 'foreignnational' ?
                                                'Foreign National' :
                                                process.env.REACT_APP_URL === 'fha203kloans' ?
                                                    'FHA 203(K)' :
                                                    process.env.REACT_APP_URL === 'jumboloans' ?
                                                    'Jumbo' :
                                                    process.env.REACT_APP_URL === 'equodpaloans' ?
                                                    'EQUO DPA' :
                                                    process.env.REACT_APP_URL.replace('loans', '').toUpperCase()

                                    )}
                                </Dropdown.Toggle> 
                                {/* landing page Urls start */}
                                <Dropdown.Menu className={`${isPrimeJumbo ? 'jumbo-page-nav-menu' : ''
                                    }`
                                }>
                                    {dropdownOption[`${process.env.REACT_APP_URL}Options`].map((item, index, array) => (
                                        <div key={item.name}>
                                            {index < array.length - 1 && ( // Check if it's not the last item
                                                <Dropdown.Item
                                                    href={item.url}
                                                    rel="noreferrer"
                                                    target="_self"
                                                    className="navbar-dropdown-item"
                                                >
                                                    {item.name}
                                                </Dropdown.Item>
                                            )}
                                        </div>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
                {/* </Navbar> */}
            </Container >
            <div id="scrollRef" style={{
                width: '0',
                height: '0'
            }}></div>

            {showSMLSLoginModal && (
                <SMLSLoginModal
                    showModal={showSMLSLoginModal}
                    modalClose={handleSMLSLoginModalClose}
                    actionType={actionType}
                />
            )}
        </div>
    );
}

export default NavBar;